import generateForms from "@/data/functions/mixins/generateForms.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import moment from "moment";
export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  mixins: [generateForms, displayFunctions],
  methods: {
    generateReportFromWork(doc, results) {
      this.btnSpinChangeDetail = true;
      // SET data source
      // SET data source
      const rtag = "E8";
      const rdid = this.generateDID("DATE", rtag);
      const ridg = this.generateIDG("date-gid");
      // GENERATE form
      let temp = this.generateReportForm(); // form is from compnew component

      // BASIC
      temp.basic.did = rdid;
      temp.basic.idg = ridg;
      temp.basic.tag = rtag;
      temp.basic.act = true; // set to true
      // eslint-disable-next-line
      temp.basic.id = this.displayDocumentIDGTypeA(doc.basic.tag, doc.basic.idg);
      temp.basic.title = doc.basic.title;
      // temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.dis = doc.char.dis;
      temp.char.life = "PM";
      temp.char.type = "ITR";
      temp.char.theme = "MAINT";
      temp.char.des = "Work done.";

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(rtag);

      // LINK ASSET
      temp.link.adid = doc.link.adid;
      temp.link.aid = doc.link.aid;
      temp.link.aidg = doc.link.aidg;
      temp.link.at = doc.link.at;

      // LINK WORK SOURCE
      temp.link.sdid = doc.basic.did;
      temp.link.sid = doc.basic.id;
      temp.link.sidg = doc.basic.idg;
      temp.link.st = doc.basic.title;
      temp.link.stag = doc.basic.tag;

      // LINK EQUIP
      // not available

      // LINK TEST Program
      temp.link.epdid = doc.link.epdid;
      temp.link.epid = doc.link.epid;
      temp.link.epidg = doc.link.epidg;
      temp.link.ept = doc.link.ept;
      temp.link.eprev = doc.link.eprev;

      // RESULTS
      let e5 = results;

      // CREATE DOC ONLY
      // this.createFirebaseDocumentOnly(temp);
      this.createFirebaseDocumentRelpsPreloaded(temp, "e5", e5);

      // HELP
      console.log("");
      console.log("NEW Technical Report Generated");
      console.log(temp);
      console.log(e5);
    },
    generateResultVisual(res) {
      let obj = {
        icon: "speed",
        des: "numerical",
        stat: "F",
        color: this.ui.btnColor,
        colorText: this.ui.textColor,
        title: "-"
      };
      if (res !== undefined && res !== null) {
        if (res.char.test === "Number") {
          let r = parseFloat(res.char.result);
          let rhi1 = parseFloat(res.char.rhi1);
          let rhi2 = parseFloat(res.char.rhi2);
          let rlo1 = parseFloat(res.char.rlo1);
          let rlo2 = parseFloat(res.char.rlo2);
          // DEFINE OBJ
          obj.title = res.char.result + res.char.unit;
          if (
            res.char.result === "" ||
            res.char.result === "NA" ||
            res.char.result === "-"
          ) {
            obj.icon = "speed";
            obj.des = "high warning";
            obj.stat = "W";
            obj.color = this.ui.colorBtn;
            obj.colorText = this.ui.textColor;
          } else if (r > rhi1 && r < rhi2) {
            obj.icon = "warning";
            obj.des = "high warning";
            obj.stat = "W";
            obj.color = this.ui.colorWarning;
            obj.colorText = this.ui.textColorWarning;
          } else if (r > rhi1 && r > rhi2) {
            obj.icon = "error";
            obj.des = "high fault";
            obj.stat = "F";
            obj.color = this.ui.colorError;
            obj.colorText = this.ui.textColorError;
          } else if (r < rlo1 && r > rlo2) {
            obj.icon = "warning";
            obj.des = "low warning";
            obj.stat = "W";
            obj.color = this.ui.colorWarning;
            obj.colorText = this.ui.textColorWarning;
          } else if (r < rlo1 && r < rlo2) {
            obj.icon = "error";
            obj.des = "low fault";
            obj.stat = "F";
            obj.color = this.ui.colorError;
            obj.colorText = this.ui.textColorError;
          } else {
            obj.icon = "speed";
            obj.des = "numerical";
            obj.stat = "F";
            obj.color = this.ui.btnColor;
            obj.colorText = this.ui.textColor;
          }
        } else {
          let r = res.char.out;
          let rin1 = res.char.rin1;
          let rin2 = res.char.rin2;
          // DEFINE OBJ
          obj.title = res.char.out;
          if (r === "NA" || r === "") {
            obj.icon = "check_box_outline_blank";
            obj.des = "defect";
            obj.stat = "F";
            obj.color = this.ui.colorBtn;
            obj.colorText = this.ui.textColor;
          } else if (r.includes(rin1) === true && r.includes(rin2) === false) {
            obj.icon = "warning";
            obj.des = "defect";
            obj.stat = "F";
            obj.color = this.ui.colorWarning;
            obj.colorText = this.ui.textColorWarning;
          } else if (r.includes(rin1) === false && r.includes(rin2) === true) {
            obj.icon = "error";
            obj.des = "fault";
            obj.stat = "F";
            obj.color = this.ui.colorError;
            obj.colorText = this.ui.textColorError;
          } else {
            obj.icon = "check_circle";
            obj.des = "result";
            obj.stat = "";
            obj.color = this.ui.colorSuccess;
            obj.colorText = this.ui.textColor;
          }
        }
      } else {
        // assign object
      }
      return obj;
    }
  }
};
